import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';

const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.REACT_APP_ENVIRONMENT || 'dev',
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
    beforeSend(event) {
      // Strip React component state/props that could contain patient data
      if (event.contexts?.react) {
        event.contexts.react = { componentStack: '[redacted]' };
      }

      // Strip local variables from stack frames
      if (event.exception?.values) {
        for (const ex of event.exception.values) {
          if (ex.stacktrace?.frames) {
            for (const frame of ex.stacktrace.frames) {
              delete frame.vars;
            }
          }
        }
      }

      // Strip breadcrumb messages from console logs (may contain patient data)
      if (event.breadcrumbs?.values) {
        for (const breadcrumb of event.breadcrumbs.values) {
          if (breadcrumb.category === 'console') {
            breadcrumb.message = '[redacted]';
            delete breadcrumb.data;
          }
        }
      }

      return event;
    },
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

